<template>
    <div id="checkout-payment-cash" class="tab-pane fade"
         :class="{ show: chosenMethod, active: chosenMethod }" role="tabpanel">
        <div class="row align-items-center">
            <div class="col-12 col-md-8">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input c-pointer" v-model="accepted"
                           type="checkbox" id="accept-cash">
                    <label v-html="$t('checkout.payment.acceptPayCash', generalInfos)"
                           class="custom-control-label c-pointer" for="accept-cash"></label>
                </div>
            </div>
            <div class="col-12 col-md-4 text-center">
                <button class="btn btn-primary" @click="setBillingMethod" :disabled="!accepted">
                    {{$t("checkout.payment.payByCash")}}
                </button>
            </div>
        </div>
        <transition name="fade">
            <div v-if="accepted" class="row">
                <div class="col-12 text-center">
                    <div class="custom-control custom-checkbox custom-control-inline">
                        <input v-model="saveAsFavoritePaymentMethod" class="custom-control-input c-pointer" type="checkbox" id="favorite-payment-method-cash">
                        <label class="custom-control-label c-pointer" for="favorite-payment-method-cash">
                            {{ $t("CheckoutPayment.favoritePaymentMethod") }}
                        </label>
                    </div>
                    <RequiredForOneClickOrder/>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import RequiredForOneClickOrder from "../../../shared/Order/RequiredForOneClickOrder";
export default {
    name: "CheckoutPaymentCash",
    components: {RequiredForOneClickOrder},
    props: {
        generalInfos: {
            type: Object,
            required: true,
        },
        preferences: {
            type: Object,
            required: true,
        },
        order: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            accepted: false,
            saveAsFavoritePaymentMethod: this.preferences.billing.method === "cash",
        };
    },
    computed: {
        chosenMethod() {
            return this.order.billing.method === "cash";
        },
    },
    methods: {
        setBillingMethod() {
            this.$emit("set-billing-method", {
                method: "cash",
                favoritePaymentMethod: this.saveAsFavoritePaymentMethod,
            });
        },
    },
};
</script>

<style scoped>

</style>